/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Size_Stage_SortingInputs */

const vi_lot_size_stage_sorting = /** @type {(inputs: Lot_Size_Stage_SortingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô phân loại`)
};

/**

* @param {Lot_Size_Stage_SortingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_size_stage_sorting = /** @type {((inputs?: Lot_Size_Stage_SortingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Size_Stage_SortingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_size_stage_sorting(inputs)
});